import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import companyLogo from '../company_logo_img.png';

const menu = [
  {
    label: '오픈소스',
    path: '/opensource',
    dropdown: [
      { name: 'Linux OS', path: '/opensource?category=linux-os' },
      { name: 'WEB/WAS', path: '/opensource?category=web-was' },
      { name: 'DBMS', path: '/opensource?category=dbms' }
    ],
  },
  {
    label: '솔루션',
    path: '/solutions',
    dropdown: [
      { name: 'RedHat', path: '/solutions?category=redhat' },
      { name: 'LENA', path: '/solutions?category=lena' },
      { name: 'Resin', path: '/solutions?category=resin' },
      { name: 'AgensSQL', path: '/solutions?category=agenssql' },
      { name: 'Oracle', path: '/solutions?category=oracle' },
      { name: 'Tibero', path: '/solutions?category=tibero' },
      { name: 'ClusterPlex', path: '/solutions?category=clusterplex' }
    ],
  },
  {
    label: '모니터링',
    path: '/monitoring',
    dropdown: [
      { name: 'Jennifer', path: '/monitoring?category=jennifer' },
      { name: 'MaxGauge', path: '/monitoring?category=maxgauge' },
      { name: 'TAMIS', path: '/monitoring?category=tamis' },
      { name: 'eG Enterprise', path: '/monitoring?category=eg-enterprise' }
    ],
  },
  {
    label: '기술서비스',
    path: '/support',
    dropdown: [
      { name: '케어팩서비스', path: '/support?category=carepack' },
      { name: 'DBMS컨설팅', path: '/support?category=dbms-consulting' }
    ],
  },
];

function Navbar() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <nav className="navbar">
      <div className="logo">
        <Link to="/">
          <img src={companyLogo} alt="제스트정보기술 로고" className="logo-image" />
        </Link>
      </div>
      <ul className="nav-links">
        {menu.map((item, idx) => (
          <li
            className={`dropdown-wrapper${openIndex === idx ? ' hover' : ''}`}
            key={item.label}
            onMouseEnter={() => setOpenIndex(idx)}
            onMouseLeave={() => setOpenIndex(null)}
          >
            <Link to={item.path}>{item.label}</Link>
            <div className="dropdown">
              {item.dropdown.map((sub, i) => (
                <Link to={sub.path} key={i}>{sub.name}</Link>
              ))}
            </div>
          </li>
        ))}
        <li>
          <a href="https://blog.naver.com/xestinf" target="_blank" rel="noopener noreferrer">기술블로그</a>
        </li>
        <li>
          <Link to="/about">회사소개</Link>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar; 